import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { shadowLight } from 'app/colors';
import { scrollbarCss } from 'app/spacing';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  height: calc(100% + 25px);
  margin-left: -15px;
  margin-right: -15px;
  user-select: none;
`;

export const Header = styled.div`
  display: flex;
  color: var(--color-font-primary);
  column-gap: ${({ mobile }) => (mobile ? 10 : 20)}px;
  padding: 4px 0 17px 15px;
  ${({ scrolled }) =>
    scrolled
      ? css`
          border-bottom: 1px solid var(--color-border-medium-light);
          ${shadowLight}
        `
      : ''}
`;

export const Cell = styled.div`
  display: flex;
  flex-grow: ${({ shrink }) => (shrink ? 0 : 1)};
  max-width: ${({ widthPercent, widthPixels }) =>
    widthPercent
      ? `${widthPercent}%`
      : widthPixels
        ? `${widthPixels}px`
        : '100%'};
  min-width: ${({ widthPercent, widthPixels }) =>
    widthPercent ? `${widthPercent}%` : widthPixels ? `${widthPixels}px` : '0'};
  justify-content: ${({ textAlign }) => textAlign ?? 'left'};
  align-items: center;
  ${({ right }) =>
    typeof right === 'number'
      ? css`
          padding-right: ${right}px;
        `
      : ''}

  // This is a hack for mobile safari so the text looks correct
  ${({ textAlign }) =>
    textAlign === 'right'
      ? css`
          & p {
            margin-left: auto;
          }
        `
      : ''}

  & p.open {
    color: var(--color-viz-cat-2-primary);
  }

  & p.won {
    color: var(--color-viz-cat-1-primary);
  }

  & p.lost,
  & p.disqualified {
    color: var(--color-viz-cat-7-secondary);
  }
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  overflow-y: auto;
  ${scrollbarCss}
`;
